import * as React from "react";
import { useFieldProps } from "src/hooks/form/useField";
import { useSelect } from "src/hooks/form/useSelect";
import { fetchDocumentsMasters } from "src/api/shipmentExecution";

const useUploadedByOrg = <T>(
  props: useFieldProps<T>,
  id: any,
) => {
  const field = useSelect(
    props,
    () => fetchDocumentsMasters(id),
    (data:any) => data?.uploadedByOrg?.map((el) => ({ key: el, label: el })) || []
  );

  return field;
};

export default useUploadedByOrg;
